// @ts-nocheck
import debounce from "lodash/debounce";
import { useEffect, useState } from "react";

/**
 * @param {callback} callback - callback function to be called when the search term changes
 * @param {debounceDelay} debounceDelay - delay in milliseconds to wait before calling the callback function
 * @returns {[searchTerm, setSearchTerm]} - searchTerm is the current search term, setSearchTerm is a function to set the search term
 */

const useSearch = (callback: (search: string) => void, debounceDelay = 200) => {
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        const debouncedSearch = debounce(callback, debounceDelay);
        debouncedSearch(searchTerm);
        return () => debouncedSearch.cancel();
    }, [searchTerm]);

    return [searchTerm, setSearchTerm] as const;
};

export default useSearch;
